import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpError } from '@windsim/core/models';
import { AuthenticationService, LoggingService } from '@windsim/core/services';

import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private authenticationService: AuthenticationService, private loggingService: LoggingService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<HttpError>> {
    return next.handle(request).pipe(
      catchError((err: HttpErrorResponse) => {
        if (err.status === 401) {
          // Only logout for critical authentication failures
          // Skip logout for non-critical operations like DeleteJobs and GetJobsStatus
          const isDeleteJobsRequest = request.url.includes('/DeleteJobs');
          const isGetJobsStatusRequest = request.url.includes('/GetJobsStatus');
          const isNonCriticalRequest = isDeleteJobsRequest || isGetJobsStatusRequest;

          if (!isNonCriticalRequest) {
            this.loggingService.consoleLogError(`401 Unauthorized error on ${request.url}. Logging out user.`);
            this.authenticationService
              .logout()
              .then()
              .catch((error) => this.loggingService.consoleLogError(error));
          } else {
            this.loggingService.consoleLogError(`401 Unauthorized error on non-critical request ${request.url}. Skipping logout.`);
          }
        }
        // Extract meaningful error content from server response
        let serverErrorContent = err.error;

        // If the server response has a specific message, use it
        if (err.error && typeof err.error === 'object') {
          if (err.error.message) {
            serverErrorContent = err.error.message;
          } else if (err.error.errors) {
            serverErrorContent = err.error.errors;
          } else if (err.error.title) {
            serverErrorContent = err.error.title;
          }
        } else if (typeof err.error === 'string') {
          serverErrorContent = err.error;
        }

        return throwError({
          statusCode: err.status,
          statusText: err.statusText,
          message: err.message,
          errors: serverErrorContent,
        });
      }),
    );
  }
}
